// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Oivw0","avatarTable":"styles_avatarTable__DAGt2"};